export default function Bar({width, color}){
  const bgcolor = color!==undefined? color:"rgba(255,255,255,0.5)";
  return <p className="my-4"
      style={{width:`${width}`, height:"2px", backgroundColor:`${bgcolor}`}}></p>;
}